import { render, staticRenderFns } from "./CourseSidebar.vue?vue&type=template&id=0122a393&scoped=true"
import script from "./CourseSidebar.vue?vue&type=script&lang=ts"
export * from "./CourseSidebar.vue?vue&type=script&lang=ts"
import style0 from "./CourseSidebar.vue?vue&type=style&index=0&id=0122a393&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0122a393",
  null
  
)

export default component.exports